/*
  WAIN99 詢問單（酒類専用の問い合わせリスト）

  なぜ買い物カゴと分けるか:
    台湾では酒類をオンラインで売れないが、周邊・可樂は実際に売っている。
    Shopify のカートを詢問單に転用すると、酒と周邊が同じカートに入った時点で
    決済が壊れる。そこで酒類だけを localStorage の別リストで扱う。

  保存先: localStorage['wain99_inquiry']
    [{ key, variantId, title, variantTitle, qty, price, url, image }]
  価格は追加時の表示文字列をそのまま持つ（マーケットで通貨が変わるため）。
*/
(function () {
  'use strict';

  var KEY = 'wain99_inquiry';
  var T = (window.WAIN99_INQUIRY_TEXT || {});

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* プライベートウィンドウ等で書けなくても画面は動かす */
    }
    document.dispatchEvent(new CustomEvent('wain99:inquiry:change', { detail: { list: list } }));
  }

  function count() {
    return read().reduce(function (n, i) { return n + (parseInt(i.qty, 10) || 0); }, 0);
  }

  function add(item) {
    var list = read();
    var found = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].key === item.key) { found = list[i]; break; }
    }
    if (found) {
      found.qty = (parseInt(found.qty, 10) || 0) + (parseInt(item.qty, 10) || 1);
    } else {
      list.push(item);
    }
    write(list);
  }

  function setQty(key, qty) {
    var list = read().map(function (i) {
      if (i.key === key) { i.qty = Math.max(1, parseInt(qty, 10) || 1); }
      return i;
    });
    write(list);
  }

  function remove(key) {
    write(read().filter(function (i) { return i.key !== key; }));
  }

  function clear() { write([]); }

  /* ---------- 商品ページの「詢問單に追加」 ---------- */

  function currentVariantId(root) {
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) { return fromUrl; }
    return root.getAttribute('data-default-variant') || '';
  }

  function currentQty() {
    var input = document.querySelector('.product-form__quantity .quantity__input, .quantity__input');
    var n = input ? parseInt(input.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function bindAdd(root) {
    var button = root.querySelector('[data-inquiry-add-button]');
    var feedback = root.querySelector('[data-inquiry-feedback]');
    if (!button) { return; }

    var variants = {};
    try { variants = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) { variants = {}; }

    button.addEventListener('click', function () {
      var vid = String(currentVariantId(root));
      var v = variants[vid] || {};
      add({
        key: vid,
        variantId: vid,
        title: root.getAttribute('data-product-title') || '',
        variantTitle: v.title && v.title !== 'Default Title' ? v.title : '',
        qty: currentQty(),
        price: v.price || '',
        url: root.getAttribute('data-product-url') || window.location.pathname,
        image: root.getAttribute('data-product-image') || ''
      });
      if (feedback) {
        feedback.hidden = false;
      }
    });
  }

  /* ---------- 画面のどこからでも開ける小さなボタン ---------- */

  function renderFloating() {
    var n = count();
    var el = document.querySelector('[data-inquiry-floating]');
    if (n === 0) {
      if (el) { el.remove(); }
      return;
    }
    if (!el) {
      el = document.createElement('a');
      el.setAttribute('data-inquiry-floating', '');
      el.className = 'wain99-inquiry-floating';
      el.href = (window.WAIN99_INQUIRY_URL || '/pages/inquiry');
      document.body.appendChild(el);
    }
    el.textContent = (T.floating || '詢問單') + ' (' + n + ')';
  }

  /* ---------- 詢問單ページ ---------- */

  function renderPage(root) {
    var listEl = root.querySelector('[data-inquiry-items]');
    var emptyEl = root.querySelector('[data-inquiry-empty]');
    var formEl = root.querySelector('[data-inquiry-form]');
    var summaryEl = root.querySelector('[data-inquiry-summary]');
    if (!listEl) { return; }

    var list = read();
    listEl.innerHTML = '';

    if (list.length === 0) {
      if (emptyEl) { emptyEl.hidden = false; }
      if (formEl) { formEl.hidden = true; }
      return;
    }
    if (emptyEl) { emptyEl.hidden = true; }
    if (formEl) { formEl.hidden = false; }

    list.forEach(function (item) {
      var row = document.createElement('li');
      row.className = 'wain99-inquiry__item';

      var img = item.image
        ? '<img class="wain99-inquiry__thumb" src="' + item.image + '" alt="" width="80" height="80" loading="lazy">'
        : '<span class="wain99-inquiry__thumb wain99-inquiry__thumb--empty"></span>';

      row.innerHTML =
        img +
        '<div class="wain99-inquiry__body">' +
          '<a class="wain99-inquiry__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>' +
          (item.variantTitle ? '<div class="wain99-inquiry__variant">' + escapeHtml(item.variantTitle) + '</div>' : '') +
          (item.price ? '<div class="wain99-inquiry__price">' + escapeHtml(item.price) + '</div>' : '') +
        '</div>' +
        '<div class="wain99-inquiry__controls">' +
          '<label class="visually-hidden" for="qty-' + item.key + '">' + escapeHtml(T.quantity || '數量') + '</label>' +
          '<input id="qty-' + item.key + '" class="wain99-inquiry__qty" type="number" min="1" value="' + (parseInt(item.qty, 10) || 1) + '" data-inquiry-qty="' + item.key + '">' +
          '<button type="button" class="link wain99-inquiry__remove" data-inquiry-remove="' + item.key + '">' + escapeHtml(T.remove || '刪除') + '</button>' +
        '</div>';

      listEl.appendChild(row);
    });

    if (summaryEl) {
      summaryEl.value = list.map(function (i) {
        return '- ' + i.title + (i.variantTitle ? ' / ' + i.variantTitle : '') +
               ' x ' + i.qty + (i.price ? ' (' + i.price + ')' : '');
      }).join('\n');
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function bindPage(root) {
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-inquiry-remove]');
      if (rm) { remove(rm.getAttribute('data-inquiry-remove')); }
    });
    root.addEventListener('change', function (e) {
      var q = e.target.closest('[data-inquiry-qty]');
      if (q) { setQty(q.getAttribute('data-inquiry-qty'), q.value); }
    });
    document.addEventListener('wain99:inquiry:change', function () { renderPage(root); });
    renderPage(root);
  }

  /* 送信できたら詢問單を空にする（Shopify は ?contact_posted=true で戻ってくる） */
  function clearAfterPost() {
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      clear();
    }
  }

  function init() {
    document.querySelectorAll('[data-inquiry-add]').forEach(bindAdd);
    var page = document.querySelector('[data-inquiry-page]');
    if (page) { clearAfterPost(); bindPage(page); }
    renderFloating();
    document.addEventListener('wain99:inquiry:change', renderFloating);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.WAIN99Inquiry = { read: read, add: add, remove: remove, clear: clear, count: count };
})();
